import { ReferencesPage } from "./ReferencesPage";
import { HomePage, PartIPage, ResearchPage } from "./ProgrammePages";
import { PartIIPage } from "./EvaluationPage";
import { PartIIIPage, PartIVPage } from "./EvidencePages";
import { ResourcesPage } from "./ResourcesPage";
import { AboutPage, ExplainersPage, PaperPage } from "./ResourcePages";

export function renderEditorialPage(path: string) {
  switch (path) {
    case "research": return <ResearchPage />;
    case "research/part-i": return <PartIPage />;
    case "research/part-ii": return <PartIIPage />;
    case "research/part-iii": return <PartIIIPage />;
    case "research/part-iv": return <PartIVPage />;
    case "references": return <ReferencesPage />;
    case "paper": return <PaperPage />;
    case "outputs": return <ResourcesPage />;
    case "explainers": return <ExplainersPage />;
    case "about": return <AboutPage />;
    default: return <HomePage />;
  }
}
